export default function Loader() {
  return (
    <div className="spinner-container">
      <div className="loading-spinner text-gray-500">Loading ......</div>
    </div>
  );
}
